import styled from 'styled-components';

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
`;

export const ButtonWrapper = styled.div`
  max-width: 160px;
`;

export const InnerModal = styled.div`
  padding: 55px 30px;
  position: absolute;
  background: ${({ theme }) => theme.base.white};

  & > div[data-testid='loading-component'] {
    margin: auto;
    padding: 24px;
  }

  @media screen and (max-width: 767px) {
    position: fixed;
    left: 20px;
    right: 20px;
  }

  > h2 {
    @media screen and (max-width: 767px) {
      white-space: initial;
    }
  }
`;

export const Subscription = styled.div`
  padding: 8px 0;
  background: ${({ theme }) => theme.base.white};

  > p {
    @media screen and (max-width: 767px) {
      white-space: initial;
    }
  }
`;

export const FollowButtonContainer = styled.div`
  position: relative;
`;

export const CheckboxGroup = styled.label`
  display: flex;
  align-items: flex-start;
  position: relative;
  font-family: ${({ theme }) => theme.fonts.primary};
  cursor: pointer;
  padding-right: 16px;
  font-size: 16px;
`;

export const NotificationContent = styled.div`
  max-width: 516px;

  h2 {
    font-size: 1.75rem;
    font-weight: 700;
    margin-bottom: 1.5rem;
  }

  h3 {
    font-size: 1.25rem;
    margin-bottom: 1rem;
  }

  label {
    align-items: center;
  }
`;
